import { RetroBag } from '@icon-park/vue'
import appStore from 'store'
import api from './api'

const store = {
  namespaced: true,
  state: {
    coinList: [],
    currentList: [],
    currentTreasure: [],
    totalCount: 0,
    pagination: {
      page: 1,
      size: 10,
    },
  },
  getters: {},
  mutations: {
    setpage(state, page) {
      state.pagination = page
    },
    setCurrentList(state, payload) {
      state.currentList = payload.data
    },
    setCurrentTreasure(state, payload) {
      state.currentTreasure = payload
    },
    setCoinList(state, payload) {
      state.coinList = payload
    },
  },
  actions: {
    getCurrentList({ commit }, params) {
      api.fetchCurrentList(params).then(({ data }) => {
        commit('setCurrentList', data)
      })
    },
    saveCurrentTreasure({ commit }, params) {
      return api.fetchCurrentSubmit(params)
    },
    // getCurrentTreasure({ commit }, params) {
    //   api.fetchCurrentDetail(params).then(({ data }) => {
    //     commit('setCurrentTreasure', data)
    //   })
    // },
    getCurrentTreasure({ commit }, params) {
      return api.fetchCurrentDetail(params)
    },
    getCurrentOrderList({ commit }, params) {
      return api.fetchCurrentOrderList(params)
    },
    setCurrentStatusSet({ commit }, params) {
      return api.fetchCurrentStatusSet(params)
    },
    fetchCurrentSwitchConf({ commit }, params) {
      return api.fetchCurrentStatusSet(params)
    },
    fetchCurrentSwitchSet({ commit }, params) {
      return api.fetchCurrentStatusSet(params)
    },
    // staking
    getStakingList({ commit }, params) {
      return api.fetchStakingList(params)
    },
    setStakingSwitchConf({ commit }) {
      return api.fetchStakingSwitchConf()
    },
    setStakingSwitchSet({ commit }, params) {
      return api.fetchStakingSwitchSet(params)
    },
    setStakingStatusSet({ commit }, params) {
      return api.fetchStakingStatusSet(params)
    },
    stakingSubmit({ commit }, params) {
      return api.fetchStakingSubmit(params)
    },
    getStakingDetail({ commit }, params) {
      return api.fetchStakingDetail(params)
    },
    getStakingOrderList({ commit }, params) {
      return api.fetchStakingOrderList(params)
    },
    getStakingOrderAgg({ commit }, params) {
      return api.fetchStakingOrderAgg(params)
    },
    setStakingBuy({ commit }, params) {
      return api.fetchStakingBuy(params)
    },
    setStakingSwitchOff({ commit }, params) {
      return api.fetchStakingSwitchOff(params)
    },
    setStakingSwitchOn({ commit }, params) {
      return api.fetchStakingSwitchOn(params)
    },
    setStakingOutSwitchOff({ commit }, params) {
      return api.fetchStakingOutSwitchOff(params)
    },
    setStakingOutSwitchOn({ commit }, params) {
      return api.fetchStakingOutSwitchOn(params)
    },
    getStakingExportOrder({ commit }, params) {
      return api.fetchStakingExportOrder(params)
    },
    setUpload({ commit }, params) {
      return api.fetchUpload(params)
    },
    getCoinList({ commit }) {
      api.fetchCoinList().then(({ data }) => {
        commit('setCoinList', data)
      })
    },
  },
}

appStore.registerModule('financial', store)
